// Epic Sale Countdown Timer
document.addEventListener('DOMContentLoaded', function() {
    // Find all countdown timers on the page
    const countdownElements = document.querySelectorAll('.epic-sale-countdown');
    
    // Process each countdown timer
    countdownElements.forEach(function(countdownElement) {
        // Get the end time from the data attribute
        const endTimeStr = countdownElement.getAttribute('data-end-time');
        if (!endTimeStr) return;
        
        const endTime = new Date(endTimeStr).getTime();
        
        // Find the countdown number elements
        const daysElement = countdownElement.querySelector('.days');
        const hoursElement = countdownElement.querySelector('.hours');
        const minutesElement = countdownElement.querySelector('.minutes');
        const secondsElement = countdownElement.querySelector('.seconds');
        
        // Update the countdown every second
        const updateCountdown = function() {
            // Get current time
            const now = new Date().getTime();
            
            // Calculate the time remaining
            const timeRemaining = endTime - now;
            
            // If the sale has ended
            if (timeRemaining <= 0) {
                if (daysElement) daysElement.textContent = '0';
                if (hoursElement) hoursElement.textContent = '0';
                if (minutesElement) minutesElement.textContent = '0';
                if (secondsElement) secondsElement.textContent = '0';
                return;
            }
            
            // Calculate days, hours, minutes, and seconds
            const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
            
            // Update the countdown display
            if (daysElement) daysElement.textContent = days;
            if (hoursElement) hoursElement.textContent = hours < 10 ? '0' + hours : hours;
            if (minutesElement) minutesElement.textContent = minutes < 10 ? '0' + minutes : minutes;
            if (secondsElement) secondsElement.textContent = seconds < 10 ? '0' + seconds : seconds;
        };
        
        // Initial update
        updateCountdown();
        
        // Update every second
        setInterval(updateCountdown, 1000);
    });
});
